import React, { useState } from 'react';
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/esm/FloatingLabel';
import Button from 'react-bootstrap/Button'
import { Row, Col } from 'react-bootstrap'
import { addText } from '../Utils/helpers';
import { adjustData } from '../Data/data';

const FormFeed = (props) => {
    // Syötettävän tekstin tila
    const [text, setText] = useState('')

    // Tekstin lisäys käyttäen Utils/apufunktioita
    const handleSubmit = (type) => {
        if(text !== '' && type === '+' && props.plusList.length < 3) {
            addText(text, type, props.setPlusList)
        } else if (text !== '' && type === '-' && props.minusList.length < 3) {
            addText(text, type, props.setMinusList)
        }
        props.setFocusId('form-group')
    }

    return (
        <Form>
            <Row className="g-2">
                <Col md="10" >
                    <Form.Group className="mb-2" controlId="form-group" >
                        <FloatingLabel controlId="form-group" label={props.label} >
                            <Form.Control
                            as="textarea"
                            style={{ height: '85px', border:'solid 1px black' }}
                            onChange={(e) => setText(e.target.value)}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col md="2" className="" >
                    <Row className="px-3">
                        <Button className="justify-content-center m-auto border-dark" variant="success" type="button" onClick={(e) => handleSubmit('+')}>{adjustData.buttons.posButton}</Button>
                    </Row>
                    <Row className="px-3 py-2">
                        <Button className="justify-content-center m-auto border-dark" variant="danger" type="button" onClick={(e) => handleSubmit('-')}>{adjustData.buttons.negButton}</Button>
                    </Row>
                </Col>
            </Row>
        </Form>
    );
};

export default FormFeed;